/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { API_PATH } from "src/environments/config";
import { ReviewService } from "./review.service";
import { HttpParams, HttpClient, HttpHeaders } from "@angular/common/http";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};
@Injectable({
  providedIn: "root",
})
export class ImageUploadService {
  constructor(private http: HttpClient, private reviewService: ReviewService) {}

  public uploadReviewImage(image: any) {
    const formData = new FormData();

    formData.append("reviewPhoto", image);
    formData.append("uploadpath", "users");

    this.http.post(`${API_PATH.apis.photoUpload}`, formData).subscribe(
      (json: any) => {
        this.reviewService.sendUploadedReviewImageData(json.imageURI);
      },
      (err) => {
        this.reviewService.sendUploadedReviewImageData(
          "https://www.gstatic.com/webp/gallery/1.jpg"
        );
      }
    );
  }
  public uploadProfileImage(image: any) {
    const formData = new FormData();

    formData.append("file", image);
    formData.append("uploadpath", "users");
    console.log(formData);

    return this.http.post(`${API_PATH.apis.photoUpload}`, formData).subscribe(
      (json: any) => {
        this.reviewService.sendUploadedProfileImageData(json);
      },
      (err) => {
        this.reviewService.sendUploadedProfileImageData(
          "https://www.gstatic.com/webp/gallery/1.jpg"
        );
      }
    );
  }
  public uploadProfileUrl(request: any) {
    // const sessionId: string = this.cookieService.get('SESSIONID');
    // httpOptions.headers = httpOptions.headers.set('Authorization', sessionId);
    return this.http.put(`${API_PATH.apis.userProfileUpdate}`, {
      profileImageURL: request.imageURI,
      croppedProfileImageURL: request.resizeImageURI,
    });
  }
}
